var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2622_12865)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2622_12865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5417 40.6227C21.8771 40.6227 21.3082 40.3861 20.8349 39.9128C20.3616 39.4396 20.125 38.8706 20.125 38.2061V21.2894C20.125 20.6248 20.3616 20.0559 20.8349 19.5826C21.3082 19.1094 21.8771 18.8727 22.5417 18.8727H27.6167C27.8785 18.1477 28.3165 17.5637 28.9307 17.1206C29.545 16.6776 30.2347 16.4561 31 16.4561C31.7653 16.4561 32.455 16.6776 33.0693 17.1206C33.6835 17.5637 34.1215 18.1477 34.3833 18.8727H39.4583C40.1229 18.8727 40.6918 19.1094 41.1651 19.5826C41.6384 20.0559 41.875 20.6248 41.875 21.2894V38.2061C41.875 38.8706 41.6384 39.4396 41.1651 39.9128C40.6918 40.3861 40.1229 40.6227 39.4583 40.6227H22.5417ZM24.9583 35.7894H33.4167V33.3727H24.9583V35.7894ZM24.9583 30.9561H37.0417V28.5394H24.9583V30.9561ZM24.9583 26.1227H37.0417V23.7061H24.9583V26.1227ZM31 20.3831C31.2618 20.3831 31.4783 20.2975 31.6495 20.1264C31.8207 19.9552 31.9062 19.7387 31.9062 19.4769C31.9062 19.2151 31.8207 18.9986 31.6495 18.8274C31.4783 18.6562 31.2618 18.5706 31 18.5706C30.7382 18.5706 30.5217 18.6562 30.3505 18.8274C30.1793 18.9986 30.0937 19.2151 30.0937 19.4769C30.0937 19.7387 30.1793 19.9552 30.3505 20.1264C30.5217 20.2975 30.7382 20.3831 31 20.3831Z",
    fill: "#D9E8F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2622_12865",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2622_12865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2622_12865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2622_12865",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardicon);
export default __webpack_public_path__ + "static/media/clipboard+icon.99b5ec57c6572bd9fce82cb19fab3659.svg";
export { ForwardRef as ReactComponent };